export const useFetchOptions = () => {
  const nuxtApp = useNuxtApp()
  return {
    fetchPolicy: import.meta.client && nuxtApp.isHydrating ? 'cache-first' : 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    pollInterval: 3_000_000,
  }
}
